<div class="w-full h-screen flex items-center relative">
  <div class="w-full flex flex-col items-center py-16">
    <div class="flex flex-col w-full items-center justify-center">
      <img alt="Logo" class="h-16" src="/assets/images/logo-blue.svg" />
      <span [title]="appVersion" class="text-neutral-400 text-2xl font-bold mt-2">{{ appName }}</span>
    </div>
    <div class="w-[30%] mt-12">
      <form (ngSubmit)="onSubmit()" [formGroup]="passwordForgetForm" class="w-full flex flex-col gap-4">
        <syn-validate on="live" variant="inline" [customValidationMessage]="validationMessageService.byName(passwordForgetForm, 'email')">
          <syn-input
            class="w-full"
            formControlName="email"
            name="email"
            [label]="'passwordForget.email' | translate"
            [title]="'passwordForget.email' | translate"
            placeholder="Email"
            type="email"
            autocomplete="email"
            required
          >
          </syn-input>
        </syn-validate>

        <syn-button
          [attr.disabled]="disableSubmitForm || null"
          variant="filled"
          type="submit"
          id="resetPasswordButton"
          style="width: 100%"
        >
          <syn-icon slot="prefix" name="send" aria-hidden="true"></syn-icon>
          {{ 'action.resetPassword' | translate }}
        </syn-button>
      </form>
      <p class="w-full mt-4 flex justify-center text-lg">
        <span class="mr-2">{{ "passwordForget.alreadyHaveAnAccount" | translate }}</span>
        <button id="redirectLoginPageButton" (click)="redirectLogin()" class="text-primary-600 hover:underline">
          {{ "login.login" | translate }}
        </button>
      </p>
    </div>
  </div>
</div>
